import React, { Component } from 'react'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import Panel from 'react-bootstrap/lib/Panel'
import ListGroup from 'react-bootstrap/lib/ListGroup'

import Loading from 'components/Loading'

class ClassList extends Component {

  render() {
    const { __classList, __classHasFetched } = this.props

    if (!__classHasFetched) {
      return <Loading />
    }

    return (
      <Panel header="Class List">
        <ListGroup fill>
          {__classList.map((item, k) => {
            // try to split subject_codes by ','
            const sp = item.get('subject_codes').split(',')
            return (
              <Link
                key={item.get('id')}
                to={`/grades/${item.get('id')}`}
                className="list-group-item"
                activeClassName="active"
              >
                <div className="pull-right">
                  <small>{item.get('section')}</small>
                </div>
                <div>
                  {sp.map((s, k) => (
                    <div key={k}><code>{s}</code></div>
                  ))}
                </div>
              </Link>
            )
          })}
        </ListGroup>
      </Panel>
    )
  }
}

function mapStateToProps(state) {
  return {
    __classHasFetched: state.grade.get('classHasFetched'),
    __classList: state.grade.get('classList'),
  }
}

export default connect(mapStateToProps)(ClassList)



// WEBPACK FOOTER //
// ./src/containers/Grades/class-list.js